<form *ngIf="visitanteInfoForm"  [formGroup]="visitanteInfoForm" class="contenedor-visitante" [class.no-editable]="!editable">
    <div class="informacion-inicio">
        <!-- Area -->
        <div>
            <label for="">Área</label>
            <input *ngIf="!editable" type="text" [readonly]="!editable" formControlName="area">
            <mat-select 
                *ngIf="editable"
                formControlName="area"
                placeholder="Seleccione"
                [class.required]="area.invalid && area.touched"
                >
                <mat-option *ngFor="let area of areas;" [value]="area">
                    {{area.descripcion}}
                </mat-option>
            </mat-select>
        </div>

        <!-- Apartamento -->
        <div>
            <label for="">Apartamento/Casa</label>
            <input *ngIf="!editable" type="text" [readonly]="!editable" formControlName="apartamento">
            <mat-select
                *ngIf="editable"
                formControlName="place_id"
                placeholder="Seleccione"
                [class.required]="area.value && place_id?.invalid && place_id?.touched"
                >
                <mat-option *ngFor="let apartamento of apartamentos;" [value]="apartamento.id">
                    {{apartamento.site_name}}
                </mat-option>
            </mat-select>
        </div>

        <!-- Autorizado por -->
        <div>
            <label for="">Autorizado por</label>
            <input *ngIf="!editable" type="text" [readonly]="!editable" formControlName="aut_name">
            <mat-select
                *ngIf="editable"
                formControlName="user_id"
                placeholder="Seleccione"
                [class.required]="place_id.value && user_id?.invalid && user_id?.touched"
                >
                <mat-option *ngFor="let miembro of miembros;" [value]="miembro.id">
                    {{miembro.name}}
                </mat-option>
            </mat-select>
        </div>

    </div>
    <hr>
    <div class="informacion-medio">
        <div>
            <label for="">Nombre visitante</label>
            <input
                formControlName="name"
                type="text"
                [readonly]="!editable"
                placeholder="Nombre visitante"
                [class.required]="name.invalid && name.touched"
                >
        </div>
        <div>
            <label for="">Tipo de documento</label>
            <input *ngIf="!editable" formControlName="type_document" type="text" [readonly]="!editable">
            <mat-select
                *ngIf="editable"
                formControlName="type_document"
                placeholder="Seleccione"
                [class.required]="type_document.invalid && type_document.touched"
                >
                <mat-option *ngFor="let tipoDocumento of tiposDeDocumentos;" [value]="tipoDocumento">
                    {{tipoDocumento}}
                </mat-option>
            </mat-select>
        </div>
        <div>
            <label for="">Número identificación</label>
            <input
                formControlName="number_document"
                type="number"
                [readonly]="!editable"
                placeholder="Ingresar número"
                [class.required]="number_document.invalid && number_document.touched"
                >
        </div>
        <div class="indicativo-celular">
            <div>
                <label for="">Indicativo</label>
                <input 
                    formControlName="indicative"
                    type="text"
                    *ngIf="!editable" 
                    [readonly]="!editable"
                    >
                <app-select-indicativo [indicativoForm]="visitanteInfoForm" [nombreCampo]="'indicative'" *ngIf="editable"></app-select-indicativo>
            </div>
            <div>
                <label for="">Celular</label>
                <input
                    formControlName="phone"
                    type="number"
                    [readonly]="!editable"
                    placeholder="Ingresar número"
                    [class.required]="phone.invalid && phone.touched"
                    >
            </div>
        </div>
        <div>
            <label for="">Fecha y hora llegada</label>
            <input formControlName="hour_checkin" type="text" [readonly]="!editable" *ngIf="!editable">
            <div class="contenedor-filtro-fecha" *ngIf="editable">
                <div class="filtro-fecha" (click)="toggleMostrarCalendarioLlegada()">
                    {{fechaHoraLlegada.format('DD-MM-YYYY HH:mm a')}}
                    <mat-icon>calendar_today</mat-icon>
                </div>
                <app-calendario-mes [diaElegido]="fechaHoraLlegada" [mostrar]="seleccionarFechaHoraLlegada" style="right: 0;" (onFechaActualizada)="actualizarFechaHoraLlegada($event)"></app-calendario-mes>
            </div>
        </div>
        <div>
            <label for="">Fecha y hora salida</label>
            <input formControlName="hour_checkout" type="text" [readonly]="!editable" *ngIf="!editable">
            <div class="contenedor-filtro-fecha" (click)="toggleMostrarCalendarioSalida()" *ngIf="editable && !fechaSalidaIndefinida">
                <div class="filtro-fecha">
                    {{fechaHoraSalida.format('DD-MM-YYYY HH:mm a')}}
                    <mat-icon>calendar_today</mat-icon>
                </div>
                <app-calendario-mes [diaElegido]="fechaHoraSalida" [mostrar]="seleccionarFechaHoraSalida" style="right: 0;" (onFechaActualizada)="actualizarFechaHoraSalida($event)"></app-calendario-mes>
            </div>
            <mat-checkbox
             [ngStyle]="{'margin-top': fechaSalidaIndefinida ? '5px' : '15px'}"
             [checked]="fechaSalidaIndefinida" (change)="cambiarFechaSalidaIndefinida($event)" *ngIf="editable">Indefinida</mat-checkbox>
        </div>
    </div>
    <hr>
    <div class="informacion-fin">
        <div>
            <label for="">Tipo de vehículo</label>
            <input formControlName="type_vehicle" type="text" [readonly]="!editable" *ngIf="!editable" >
            <mat-select *ngIf="editable" formControlName="type_vehicle" placeholder="Seleccione vehículo">
                <mat-option *ngFor="let vehiculo of vehiculos;" [value]="vehiculo">
                    {{vehiculo}}
                </mat-option>
            </mat-select>
        </div>
        <div class="placa-marca">
            <div>
                <label for="">Placas</label>
                <input formControlName="plate_vehicle" type="text" [readonly]="!editable" maxlength="6" placeholder="Placa">
            </div>
            <div>
                <label for="">Marca</label>
                <input type="text" [readonly]="!editable" placeholder="Ingrese marca" [formControlName]="editable ? 'mark' : 'brand_vehicle'">
            </div>
        </div>
        <div>
            <label for="">Comentarios</label>
            <textarea formControlName="note" name="" [readonly]="!editable" placeholder="Ingresar comentario"></textarea>
        </div>
    </div>
</form>
<mat-spinner *ngIf="!visitanteInfoForm || cargando"></mat-spinner>

<app-botones-cambios *ngIf="editable" [mostrar]="visitanteInfoForm" (onGuardar)="crearVisitante()" (onCancelar)="volverAVisitantes()" style="margin-left: auto;"></app-botones-cambios>
<app-botones-cambios *ngIf="!editable && estaActivo" [mostrar]="estaActivo" [ocultarBotonSecundario]="true" [textoBotonPrincipal]="'Registrar Ingreso'" (onGuardar)="registrarVisitante()" style="margin-left: auto;"></app-botones-cambios>
<meta name="viewport" content="width=device-width, initial-scale=1">